import {AnimationFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/AnimationFunctions';
import {ApiFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/ApiFunctions';
import {ArrayFormulaFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/ArrayFormulaFunctions';
import {AuthFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/AuthFunctions';
import {CacheFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/CacheFunctions';
import {CellFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/CellFunctions';
import {DateFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/DateFunctions';
import {DnDFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/DnDFunctions';
import {DomFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/DomFunctions';
import {ExportFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/ExportFunctions';
import {ExtractFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/ExtractFunctions';
import {FileFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/FileFunctions';
// import {FinancialFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/FinancialFunctions';
import {FramesFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/FramesFunctions';
import {JsonFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/JsonFunctions';
import {LearnExperienceFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/LearnExperienceFunctions';
import {LogicalFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/LogicalFunctions';
import {LookupFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/LookupFunctions';
import {MathFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/MathFunctions';
import {SalesforceFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/SalesforceFunctions';
import {StreamingFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/StreamingFunctions';
import {SurfaceFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/SurfaceFunctions';
import {TableFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/TableFunctions';
import {TestFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/TestFunctions';
import {TextFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/TextFunctions';
import {TimerFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/TimerFunctions';
import {WebFunctions} from '@mintdata-wsp/common/controllers/spreadsheet/functions/WebFunctions';
import {FunctionContainerCtor} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/ClientFunction';

export class AllBuiltinFunctions
{
    public static ContainerCtors:FunctionContainerCtor[] =
        [
            TestFunctions,
            MathFunctions,
            WebFunctions,
            AuthFunctions,
            CellFunctions,
            TimerFunctions,
            // FinancialFunctions,
            ExtractFunctions,
            TextFunctions,
            LogicalFunctions,
            DateFunctions,
            LookupFunctions,
            StreamingFunctions,
            SalesforceFunctions,
            ArrayFormulaFunctions,
            JsonFunctions,
            CacheFunctions,
            FileFunctions,
            SurfaceFunctions,
            FramesFunctions,
            DomFunctions,
            DnDFunctions,
            TableFunctions,
            ExportFunctions,
            LearnExperienceFunctions,
            AnimationFunctions,
            ApiFunctions
        ];
}
